import { ChangeDetectionStrategy, Component, HostBinding, input, output } from '@angular/core';

@Component({
	selector: 'lib-checkbox-form-input',
	templateUrl: './checkbox-form-input.component.html',
	styleUrls: ['./checkbox-form-input.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class CheckboxFormInputComponent {
	public readonly label = input<string>();
	public readonly checked = input<boolean>(false);
	public readonly valueChange = output<boolean>();

	@HostBinding('style') style = 'display: block';

	handleModelChange(value: boolean): void {
		this.valueChange.emit(value);
	}

	handleClick(event: Event): void {
		event.stopPropagation();
	}
}
